const sendToApp = args => {
  if (!window.ReactNativeWebView || !window.ReactNativeWebView.postMessage) {
    return
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({ type: 'tracker', ...args })
  )
}

const getProductById = (id, cart) => {
  let productFound = null

  const findProduct = product => {
    if (product.productId === id) {
      productFound = product
    }
  }

  cart.shippings.forEach(shipping => shipping.items.forEach(findProduct))

  return productFound
}

const addToCart = (product, cart) => {
  const productData = getProductById(product.id, cart)

  sendToApp({
    event: 'add_to_cart',
    properties: {
      currency: 'BLR',
      items: [
        {
          item_id: productData.productId,
          item_name: productData.name,
          price: parseFloat(productData.price.to),
          currency: 'BLR',
          quantity: productData.quantity
        }
      ],
      value: parseFloat(productData.price.total)
    }
  })
}

const freightCosts = cart => {
  sendToApp({
    event: 'shipping',
    properties: {
      currency: 'BLR',
      shipping: parseFloat(cart.freightCost)
    }
  })
}

const purchase = context => {
  sendToApp({
    event: 'purchase',
    properties: {
      currency: 'BLR',
      ...context
    }
  })
}

const addToWishlist = product => {
  const priceInteger = product.price.to.integers.toString()
  const integer = parseInt(priceInteger.replace(/\D/g, ''))

  sendToApp({
    event: 'add_to_wishlist',
    properties: {
      currency: 'BLR',
      items: [
        {
          item_id: product.id,
          item_name: product.shortName,
          price: parseFloat(`${integer}.${product.price.to.decimals}`),
          currency: 'BLR',
          quantity: 1
        }
      ],
      value: parseFloat(`${integer}.${product.price.to.decimals}`)
    }
  })
}

const clickBanner = banner => {
  sendToApp({
    event: 'clickBanner',
    properties: {
      page_url: banner.url,
      category: banner.category,
      label: banner.label,
      action: banner.action
    }
  })
}

export default {
  addToCart,
  freightCosts,
  purchase,
  addToWishlist,
  clickBanner
}
